import { render, staticRenderFns } from "./OptionPermission.vue?vue&type=template&id=e37d0138"
import script from "./OptionPermission.vue?vue&type=script&lang=js"
export * from "./OptionPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports